import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { DealLiteModel } from "../../viewModels/Deal/DealModel";
import SortObject from "../../types/SortObject";
import dealNotificationModalSlice from "../../widgets/DealNotificationModal/reducer";
import globalSlice from "../App/reducer";
import { DealsTableFilters as DealsFiltersType, DealsTableQuery } from "./components/DealsTableView/utils/dealsTableQuery";

const pageSizeLsKey = "deals_table_pageSize";
const pageSizeFromLs = localStorage.getItem(pageSizeLsKey);

const initialState: {
  loading: boolean;
  loadingData: boolean;
  exportLoading: boolean;
  error: boolean;
  page: number;
  pageSize: number;
  deals?: Array<DealLiteModel>;
  sort?: SortObject;
  total?: number;
  filters?: DealsFiltersType;
} = {
  loading: true,
  loadingData: false,
  exportLoading: false,
  error: false,
  page: undefined!,
  pageSize: pageSizeFromLs ? +pageSizeFromLs : 10,
};

const dealsSlice = createSlice({
  name: "deals",
  initialState,
  reducers: {
    exportDeals(state) {
      state.exportLoading = true;
    },
    exportDealsSuccess(state) {
      state.exportLoading = false;
    },
    exportDealsReject(state) {
      state.exportLoading = false;
    },
    loadDeals(state, action: PayloadAction<DealsTableQuery>) {
      state.error = false;
      state.loadingData = true;
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize || 10;
      state.filters = action.payload.filters;
      state.sort = action.payload.sort;
    },
    loadDealsSuccess(state, action: PayloadAction<{ deals?: Array<DealLiteModel>; total: number }>) {
      const { deals, total } = action.payload;

      state.loading = false;
      state.loadingData = false;
      state.deals = deals;
      state.error = false;
      state.total = total;
    },
    loadDealsReject(state) {
      state.loading = false;
      state.loadingData = false;
      state.error = true;
    },

    updateDeal(state, _action: PayloadAction<DealLiteModel>) {
      state.loadingData = true;
    },
    updateDealSuccess(state, action: PayloadAction<DealLiteModel>) {
      state.loadingData = false;
      if (state.deals) {
        const index = state.deals?.findIndex((x) => x.id === action.payload.id);
        if (index !== -1) {
          state.deals[index] = action.payload;
        }
      }
    },

    updateDealReject(state) {
      state.loadingData = false;
    },

    loadPaymentCalendar(state) {
      state.loadingData = true;
    },
    loadPaymentCalendarSuccess(state) {
      state.loadingData = false;
    },
    loadPaymentCalendarReject(state) {
      state.loadingData = false;
    },
  },
  extraReducers(builder) {
    builder.addCase(dealNotificationModalSlice.actions.createDealNotificationSuccess, (state, action) => {
      if (state.deals) {
        const dealIndex = state.deals.findIndex((x) => x.id === action.payload.deal.id);
        if (dealIndex !== -1) {
          state.deals[dealIndex].dealNotifications.unshift(action.payload);
        }
      }
    });
    builder.addCase(globalSlice.actions.sendDealNotificationResponseSuccess, (state, action) => {
      if (state.deals) {
        const dealIndex = state.deals.findIndex((x) => x.id === action.payload.deal.id);
        if (dealIndex !== -1) {
          const notificationIndex = state.deals[dealIndex].dealNotifications.findIndex((x) => x.id === action.payload.id);
          if (notificationIndex !== -1) {
            state.deals[dealIndex].dealNotifications[notificationIndex] = action.payload;
          }
        }
      }
    });
    builder.addCase(globalSlice.actions.closeDealNotificationSuccess, (state, action) => {
      if (state.deals) {
        const dealIndex = state.deals.findIndex((x) => x.id === action.payload.deal.id);
        if (dealIndex !== -1) {
          const notificationIndex = state.deals[dealIndex].dealNotifications.findIndex((x) => x.id === action.payload.id);
          if (notificationIndex !== -1) {
            state.deals[dealIndex].dealNotifications[notificationIndex] = action.payload;
          }
        }
      }
    });
  },
});

export default dealsSlice;
